"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sweetAlertHideComplete = exports.sweetAlertHide = void 0;
const constants_1 = require("../constants");
const sweetAlertHide = () => ({
    type: constants_1.SWEET_ALERT_HIDE,
    payload: {
        show: false,
    },
});
exports.sweetAlertHide = sweetAlertHide;
const sweetAlertHideComplete = () => ({
    type: constants_1.SWEET_ALERT_HIDE_COMPLETE,
});
exports.sweetAlertHideComplete = sweetAlertHideComplete;
